import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { VideoType, parseVideo } from './video-parser';
@Component({
  selector: 'store-videos',
  templateUrl: './videos.component.html',
  standalone: false,
})
export class VideosComponent implements OnInit {
  constructor(private sanitizer: DomSanitizer) {}
  @Input() videos: string[];
  videoTOs: VideoTO[] = [];
  ngOnInit(): void {
    if (this.videos && this.videos.length > 0) {
      for (let i = 0; i < this.videos.length; i++) {
        const videoTO = this.createVideo(this.videos[i]);
        if (videoTO && videoTO.videoType && videoTO.videoId && videoTO.videoId.length > 2) {
          this.videoTOs.push(videoTO);
        }
      }
    }
  }

  createVideo(url: string): VideoTO | null {
    const video = parseVideo(url);
    return video ? new VideoTO(video.url, video.type, video.id, this.sanitizer) : null;
  }
}

export class VideoTO {
  videoUrl: string;
  videoType: VideoType;
  videoId: string;
  safeUrl: SafeResourceUrl;
  public constructor(url: string, type: VideoType, id: string, sanitizer: DomSanitizer) {
    this.videoUrl = url;
    this.videoType = type;
    this.videoId = id;
    this.safeUrl = sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
